import { Card, Skeleton } from "@heroui/react";
import LoopOverviewPanelSkeleton from "./loop-overview-panel-skeleton";

const LoopDetailsSkeleton = () => {
  return (
    <Card className="w-full">
      <Card.Header className="flex-row gap-4 relative">
        <Skeleton className="size-12 rounded-full shrink-0" />

        <div className="flex flex-col gap-2">
          <Skeleton className="h-5 w-40 rounded-lg" />
          <Skeleton className="h-4 w-56 rounded-lg" />
        </div>

        <div className="flex items-center gap-1 absolute inset-e-0">
          <Skeleton className="size-9 rounded-full" />
          <Skeleton className="size-9 rounded-full" />
        </div>
      </Card.Header>

      <Card.Content className="flex flex-col gap-6">
        {/* Tab row */}
        <div className="flex items-center gap-6 border-b pb-3">
          <Skeleton className="h-5 w-16 rounded-lg" />
          <Skeleton className="h-5 w-18 rounded-lg" />
          <Skeleton className="h-5 w-20 rounded-lg" />
          <Skeleton className="h-5 w-14 rounded-lg" />
        </div>

        {/* Overview is the default active tab, so mirror its layout here */}
        <LoopOverviewPanelSkeleton />
      </Card.Content>
    </Card>
  );
};

export default LoopDetailsSkeleton;